module.exports = __webpack_public_path__ + "img/NEW_CARD_ADDED.png";